import { render, staticRenderFns } from "./SideMenuBlock.vue?vue&type=template&id=4adf4e7b&scoped=true&lang=pug&"
import script from "./SideMenuBlock.vue?vue&type=script&lang=js&"
export * from "./SideMenuBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adf4e7b",
  null
  
)

export default component.exports